import React, { useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import ModularBlocks from '../components/ModularBlocks';
import NewsletterSignup from '../components/NewsletterSignup';

const HomePage = () => {
  const {
    contentfulHome: {
      title,
      metaDescription,
      bannerText,
      bannerHeading,
      bannerImages,
      bannerUsps,
      bannerLinks,
      modularBlocks,
    },
    site: { siteMetadata },
    contentfulSitewide: {
      defaultOpenGraphImage,
      facebookLink,
      instagramLink,
      twitterXLink,
      tikTokLink,
      linkedInLink,
      emailAddress,
      phoneNumber,
    },
  } = useStaticQuery(graphql`
    query HomePageQuery {
      contentfulHome {
        title
        metaDescription
        bannerText {
          raw
        }
        bannerHeading
        bannerImages {
          gatsbyImageData(width: 470, placeholder: BLURRED)
          title
        }
        bannerUsps
        bannerLinks {
          text
          pageUrl {
            ...LinkFragment
          }
        }
        modularBlocks {
          ...AccordionModularBlockFragment
          ...CustomerReviewsModularBlockFragment
          ...FeaturedLogosModularBlockFragment
          ...FeaturedPlansModularBlockFragment
          ...ImageContentBannerSliderModularBlockFragment
          ...LatestCommunityStoriesModularBlockFragment
          ...VideoContentBannerModularBlockFragment
        }
      }
      site {
        siteMetadata {
          title
        }
      }
      contentfulSitewide {
        defaultOpenGraphImage {
          ...SeoOgImageFragment
        }
        facebookLink {
          ...LinkFragment
        }
        instagramLink {
          ...LinkFragment
        }
        twitterXLink {
          ...LinkFragment
        }
        tikTokLink {
          ...LinkFragment
        }
        linkedInLink {
          ...LinkFragment
        }
        emailAddress
        phoneNumber
      }
    }
  `);

  const [bannerLogoInView, setBannerLogoInView] = useState(true);

  return (
    <Layout
      seo={{
        title: title,
        metaDescription: metaDescription,
        location: {
          pathname: '/',
        },
      }}
      hideHeaderLogo={bannerLogoInView}
    >
      <Helmet>
        <script type="application/ld+json">
          {`{
            "@context": "https://schema.org",
            "@type": "Organization",
            "image": "${defaultOpenGraphImage.gatsbyImageData.images.fallback.src}",
            "url": "${process.env.GATSBY_SITE_URL}",
            "sameAs": [
              "${facebookLink.url}",
              "${instagramLink.url}",
              "${twitterXLink.url}",
              "${tikTokLink.url}",
              "${linkedInLink.url}",
              "${`https://uk.trustpilot.com/review/${process.env.GATSBY_SITE_URL.replace('https://www.', '')}`}"
            ],
            "logo": "${process.env.GATSBY_SITE_URL}/logo.svg",
            "name": "${siteMetadata.title}",
            "description": "${metaDescription}",
            "email": "${emailAddress}",
            "telephone": "${phoneNumber}"
          }`}
        </script>
      </Helmet>
      <main>
        <Banner
          text={bannerText}
          heading={bannerHeading || title}
          images={bannerImages}
          usps={bannerUsps}
          links={bannerLinks}
          setBannerLogoInView={setBannerLogoInView}
        />
        <ModularBlocks items={modularBlocks} />
        <NewsletterSignup />
      </main>
    </Layout>
  );
};

export default HomePage;
